import React from "react";
import "./channelsocialmediacard.scss";

export interface IChannelSocialMediaCard {
    image: string
    name: string
    viewer: string
    options: string[]
    cardID: number
    activateSocialMedia: string
    setActivateSocialMedia: React.Dispatch<React.SetStateAction<string>>
}

const ChannelSocialMediaCard = ({
                                    image,
                                    name,
                                    viewer,
                                    options,
                                    cardID,
                                    activateSocialMedia,
                                    setActivateSocialMedia
                                }: IChannelSocialMediaCard) => {
    return (
        <div
            className={activateSocialMedia === `card${cardID}` ? "Channel-Social-Media-Card active" : "Channel-Social-Media-Card"}
            onClick={() => {
                setActivateSocialMedia(`card${cardID}`);
            }}>
            <div className="Social-Media-Card-Header text-center">
                <img src={image} alt="" className="img-fluid mx-auto"/>
                <h6 className="Social-Media-Card-Header-Name">{name}</h6>
                <h6 className="Social-Media-Card-Header-Follower">{viewer}</h6>
            </div>
            <div className="Social-Media-Card-Body">
                {
                    options.map((option, index) => {
                        return (
                            <p className="Social-Media-Card-Body-Options" key={index}>
                                &nbsp;&nbsp;&nbsp;
                                &#x2022;
                                &nbsp;&nbsp;&nbsp;
                                {option}
                            </p>
                        );
                    })
                }
            </div>
        </div>
    );
}

export default ChannelSocialMediaCard;